import { useTranslate } from "ra-core";

/**
 * Draghåndtaket på høyre kant av en kolonneoverskrift. Brukes både av
 * DataTable og av det håndlagde rutenettet i prosjektlista, så utseendet og
 * treffområdet er likt de to stedene.
 *
 * Håndtaket er 1 px synlig, men har et 8 px bredt treffområde – en 1 px kant
 * er ikke til å treffe med mus. Det ligger helt inne i cellen (`right-0`), og
 * ikke halvveis utenfor: hodecellen har `overflow-hidden` for å klippe lange
 * overskrifter, og det klipper også treffområdet.
 */
export const ColumnResizeHandle = ({
  onPointerDown,
}: {
  onPointerDown: (event: React.PointerEvent<HTMLElement>) => void;
}) => {
  const translate = useTranslate();
  return (
    <span
      role="separator"
      aria-orientation="vertical"
      aria-label={translate("crm.list.resize_column", {
        _: "Endre kolonnebredde",
      })}
      onPointerDown={onPointerDown}
      // Klikk skal aldri boble videre til sorteringsknappen bak håndtaket.
      onClick={(event) => event.stopPropagation()}
      className="absolute top-0 right-0 z-10 h-full w-2 cursor-col-resize touch-none select-none before:absolute before:top-1 before:right-0 before:bottom-1 before:w-px before:bg-transparent hover:before:bg-primary"
    />
  );
};
